import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { DevisCTA } from "@/components/DevisCTA";

const chapters = [
  { n: "01", title: "Notre métier", text: "Sandro Services 06 est une entreprise locale spécialisée dans l'entretien et l'amélioration des espaces extérieurs : jardins, surfaces à nettoyer et petits travaux du quotidien." },
  { n: "02", title: "Le travail soigné", text: "Nous portons une attention particulière à la qualité des finitions. Chaque chantier est réalisé avec méthode et le souci du détail." },
  { n: "03", title: "La proximité", text: "Implantée dans les Alpes-Maritimes, l'entreprise intervient au plus près de ses clients, à l'écoute de leurs besoins." },
  { n: "04", title: "La polyvalence", text: "Entretien, nettoyage, restauration et petits travaux : une seule entreprise pour prendre soin de l'ensemble de vos extérieurs." },
  { n: "05", title: "L'écoute", text: "Nous adaptons nos interventions à la nature de chaque projet, en toute transparence." },
];

export default function APropos() {
  return (
    <div data-testid="apropos-page">
      <Seo title="À propos — Sandro Services 06 | Entreprise locale des Alpes-Maritimes" description="Sandro Services 06, entreprise locale spécialisée dans l'entretien et l'amélioration des espaces extérieurs dans les Alpes-Maritimes." />
      <PageHero chapter="À propos" title="À propos de Sandro Services 06" subtitle="Une entreprise locale spécialisée dans l'entretien et l'amélioration des espaces extérieurs.">
        <div className="mt-8 relative h-[300px] md:h-[440px] rounded-2xl overflow-hidden grain shadow-soft">
          <img src="https://images.pexels.com/photos/34174881/pexels-photo-34174881.jpeg?auto=compress&cs=tinysrgb&w=1600" alt="Le travail du jardinier" className="w-full h-full object-cover" />
        </div>
      </PageHero>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 py-14 md:py-24">
        <div className="divide-y divide-line">
          {chapters.map((c) => (
            <Reveal key={c.n}>
              <div className="grid md:grid-cols-[120px_1fr] gap-6 md:gap-12 py-10 md:py-14 group">
                <span className="font-display text-5xl md:text-6xl text-olive/40 group-hover:text-olive transition-colors">{c.n}</span>
                <div>
                  <h2 className="font-display text-3xl md:text-4xl text-forest">{c.title}</h2>
                  <p className="mt-4 text-ink-soft text-lg leading-relaxed max-w-2xl">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <DevisCTA title="Envie de travailler avec nous ?" />
    </div>
  );
}
